export const APP_UI_KEYS = {
    workspaceBar: 'workspaceBar',
    exitAppFlow: 'exitAppFlow',
    logoutFlow: 'logoutFlow',
    pinningFlow: 'pinningFlow',
    diagnosticReportFlow: 'diagnosticReportFlow',
};
export const STORAGE_IS_WORKSPACE_BAR_EXPANDED = 'workspace_bar_expanded';
